export const initialState = {
  values: [],
  changed: false
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnPropertyUserGroupChanged':
      return onPropertyUserGroupChanged(state, action);
    case 'OnPropertyUserGroupAdded':
      return onPropertyUserGroupAdded(state, action);
    case 'OnPropertyUserGroupUpdated':
      return onPropertyUserGroupUpdated(state, action);
    case 'OnPropertyUserGroupDelete':
      return onPropertyUserGroupDelete(state, action);
    case 'OnCancelPropertyUserGroup':
      return onCancelPropertyUserGroup(state, action);
    case 'OnEditPropertyUserGroup':
      return onEditPropertyUserGroup(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data } = action;
  const valuesWithInEdit = data.map(value => ({
    ...value,
    inEdit: false
  }));
  return {
    ...state,
    values: valuesWithInEdit,
    changed: false
  };
}

function onPropertyUserGroupChanged(state, action) {
  const { propName, propValue, index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        editValue: {
          ...state.values[index].editValue,
          [propName]: propValue
        }
      }
    }),
    changed: true
  };
}

function onPropertyUserGroupAdded(state, action) {
  const newPropertyUserGroup = {
    propertyId: action.propertyId,
    userGroupId: null,
    allowRead: true,
    allowWrite: true,
    inEdit: true,
    editValue: {
      propertyId: action.propertyId,
      userGroupId: null,
      allowRead: true,
      allowWrite: true
    }
  };
  const propertyUserGroups = state.values ? Object.assign([...state.values]) : [];
  propertyUserGroups.unshift({ ...newPropertyUserGroup });
  return {
    ...state,
    values: propertyUserGroups,
    changed: true
  };
}

function onPropertyUserGroupUpdated(state, _action) {
  const updatedValues = state.values.map(value => ({ ...value, ...value.editValue, inEdit: false }));

  return {
    ...state,
    values: updatedValues,
    changed: false
  };
}

function onPropertyUserGroupDelete(state, action) {
  const { index } = action;
  const newPropertyUserGroups = Object.assign([...state.values]);
  newPropertyUserGroups.splice(index, 1);
  return {
    ...state,
    values: newPropertyUserGroups,
    changed: true
  };
}

function onCancelPropertyUserGroup(state, action) {
  const { index } = action;
  const updatedValues = state.values
    .map((value, idx) => (index === idx ? { ...value, inEdit: false } : value))
    .filter((value, idx) => {
      return idx !== index || value.userGroupId !== null;
    });
  return {
    ...state,
    values: updatedValues
  };
}

function onEditPropertyUserGroup(state, action) {
  const { index } = action;
  const updatedValues = state.values.map((value, idx) => {
    if (idx === index) {
      // eslint-disable-next-line no-unused-vars
      const { inEdit, ...rest } = value;
      return {
        ...value,
        editValue: { ...rest },
        inEdit: true
      };
    }
    return value;
  });

  return {
    ...state,
    values: updatedValues
  };
}
